export function normalizeTokens(tokens) {
    return {
        idToken: tokens.id_token,
        refreshToken: tokens.refresh_token,
    };
}
